import React from 'react';
import PropTypes from 'prop-types';
import {MapContainer, MapConsumer, TileLayer} from 'react-leaflet';
import HousePOI from './HousePOI';

export default class ImmoMap extends React.Component {

    static propTypes = {
        width: PropTypes.any,
        height: PropTypes.any,
        center: PropTypes.any,
    }

    componentDidMount() {
        this.interval = setInterval(() => this.map && this.map.invalidateSize(), 25);
    }

    componentWillUnmount() {
        this.interval && clearInterval(this.interval);
    }

    render() {
        const position = this.props.center || HousePOI.defaultPosition;
        const options = {maxZoom: 18, id: 'mapbox.streets'};
        const width = this.props.width;
        const height = this.props.height;
        const that = this;
        return (
            <MapContainer
                style={{width: width, height: height}}
                center={position}
                zoom={14}
            >
                <MapConsumer>
                    {(map) => {
                        map.panTo(position);
                        that.map = map;
                        return null;
                    }}
                </MapConsumer>
                <TileLayer
                    url="https://map.rohdenburg-online.de/?r={s}&z={z}&x={x}&y={y}"
                    attribution={''}
                    options={options}
                />
                {this.props.children}
            </MapContainer>
        );
    }
}
